export const STICKY_BAR_ID = 'room-details-sticky-bar';

export enum RoomRateFormStepNames {
  GUESTS = 'guestDetailsStep',
  EXTRAS = 'extras',
}

import { FormStep } from '@common/components/BookingForms';
import { ParsedJourneyParams } from '@store/yourJourney/selectors';
import { some } from '@utils/some';
import { Guest } from 'shared-types/Basket';
import { RoomExtra } from 'shared-types/Room';
import { ExtrasStep } from './ExtrasStep';
import { GuestDetailsStep } from './GuestDetailsStep';
import { MultiRoomGuestDetailsStep } from './MultiRoomGuestDetailsStep';
import { EntityListItem, findSelectedEntity } from './selectedEntity.helper';

type GetFormStepsParams = {
  basketGuests: Guest[];
  journeyParams: ParsedJourneyParams;
  addToBasket: (...args: any[]) => Promise<void>;
  setIsSignInModalOpen: (val: boolean) => void;
  metaEntity: {
    type: 'room' | 'rate';
    id: string;
    title?: string;
    rates?: EntityListItem[];
    rooms?: EntityListItem[];
  };
  entity: { type: 'room' | 'rate'; id: string };
  goToNextStep: () => void;
  totalGuestAmount: number;
  availableExtras: RoomExtra[] | null;
  loggedGuest?: Guest | null;
};

export const getFormSteps = ({
  basketGuests,
  journeyParams,
  addToBasket,
  setIsSignInModalOpen,
  metaEntity,
  entity,
  goToNextStep,
  totalGuestAmount,
  availableExtras,
  loggedGuest,
}: GetFormStepsParams) => {
  const selectedEntity = findSelectedEntity(metaEntity, entity.id);

  const isMultiRoom = some(journeyParams.rooms) && journeyParams.rooms.length > 1;
  const rooms = journeyParams.rooms ?? [];

  const guestsProps = {
    selectedEntity,
    stickyBarId: STICKY_BAR_ID,
    basketGuests,
    datePartyData: journeyParams,
    addToBasket,
    goToNextStep,
    handleSignInModalOpen: () => setIsSignInModalOpen(true),
    metaEntity,
    availableExtras,
    totalGuestAmount,
    loggedGuest,
  };

  const extrasProps = {
    selectedEntity,
    stickyBarId: STICKY_BAR_ID,
    addToBasket,
    goToNextStep,
    metaEntity,
    entity,
    availableExtras,
    isMultiRoom,
    rooms,
  };

  return {
    [RoomRateFormStepNames.GUESTS]: (
      <FormStep isNarrow noGutter key={0}>
        {isMultiRoom ? (
          <MultiRoomGuestDetailsStep {...guestsProps} />
        ) : (
          <GuestDetailsStep {...guestsProps} />
        )}
      </FormStep>
    ),
    [RoomRateFormStepNames.EXTRAS]: (
      <FormStep isNarrow noGutter key={1}>
        <ExtrasStep {...extrasProps} />
      </FormStep>
    ),
  };
};
